import { Component, OnInit, Input, Output } from '@angular/core';
import { HistoricVar, QueryReadings } from '../../entities/devices/device.model';
import { DatePipe } from '@angular/common';
import { Constants } from '../constants';
import { DevicesService } from '../../entities/devices/devices.service';
import { EventEmitter } from '@angular/core';
import { SessionStateService } from '../../core/services/session-state.service';
import { SharedUtils } from '../shared.utils';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})

export class GraphComponent implements OnInit {
  @Output() modeChange: EventEmitter<Array<any>> = new EventEmitter();
  @Output() lastPrediction: EventEmitter<Number> = new EventEmitter();

  @Input() isPrediction?: boolean;
  /**Main Input */
  @Input() controlType: string;
  @Input() sourceId: string;
  @Input() variable: string;
  @Input() groupFields: number[];

  SharedUtils = SharedUtils;
  /**Main*/
  graphReadings: QueryReadings;
  activeView = 'day';
  mode = 'kWh';
  selectionSeconds = '3600';
  selectedDate: string;
  integrationPeriodType = '0';
  spainClient = false;
  public ChartType = 'bar';
  public ChartLabels: string[];
  public ChartLegend = false;
  public ChartData: any[] = [];
  public ChartColors: Array<any>;
  public selectedMoments;

  currentYear = String(new Date(Date.now()).getFullYear());
  /**Aux */
  totalValue: number;
  max = new Date(Date.now());
  maxValue = 0;
  currentSelectedDate = new Date(Date.now());
  numberOfTariffs = 1;
  allSchedules = true;
  normalSchedules = true;
  economicSchedules = true;
  superEconomicSchedules = true;
  noData = false;
  nextArrowPossible = false;
  previousView: string;

  /**Controls */
  loaded = false;
  lineLoaded = false;
  /**Chart Options */
  public ChartOptions: any = {
    scaleShowVerticalLines: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          color: '#ECECEC',
          display: false
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          color: '#ECECEC',
          display: true
        },
        ticks: {
          min: 0
        }
      }]
    }
  };

  constructor(private datePipe: DatePipe,
    private devicesService: DevicesService,
    private sessionSateService: SessionStateService,
    private generalService: GeneralService) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/graph/graph.component.ts